import { useEffect, useState } from "react";

// store
import useAuthStore from "store/useAuthStore";

// components
import { Spinner } from "components/icons";

import styles from "./ProtectedRoute.module.scss";

type ProtectedRouteProps = {
  children: React.ReactNode;
};

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, loginOkta } = useAuthStore();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginOkta();
    }
  }, [isLoading, isAuthenticated, loginOkta]);

  if (isLoading || !isAuthenticated) {
    return (
      <div className={styles["protected-route-root"]}>
        <Spinner />
        <p>Checking authentication...</p>
      </div>
    );
  }

  return <>{children}</>;
}
